import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
export default {
	extends: Pie,
	mixins: [reactiveProp],
	props: ['options'],
	computed: {
		colors() {
			var colors = this.$store.getters.getColors;
			return colors;
		}
	},
	mounted () {
		this.chartData.datasets.forEach( (d) => {
			d.backgroundColor = [];
			d.data.forEach( (a, i) => {
				a;
				d.backgroundColor.push(this.colors[i])
			})
		})
		this.renderChart(this.chartData, this.options)
	},
	destroyed(){
		this.chartData.datasets.forEach( (d, i) => {
			d.backgroundColor = this.colors[i]
		} )
	}
}